export enum Alert {
  'INFO',
  'ERROR',
  'SUCCESS',
  'WARNING',
  'BASIC',
}
